import React from 'react'
import { Column } from '@components/Common'
import ProfessionalSidebarLinkGroup from './ProfessionalLinkgroup'
import { generateRandomKey } from '@utils'

const ProfessionalSidebar = ({ pageSlugs, sidebar }) => {
  const sidebarTitles = [
    { name: 'Practice Areas' },
    { name: 'Languages' },
    { name: 'Admissions' },
    { name: 'Education' },
    { name: 'Accolades' },
    { name: 'Links' },
  ]
  return (
    <Column className="qtph-profprofile-sidebar sm:w-5/6 md:w-[37.5%] lg:w-1/4 xl:w-[20.8%] lg:ml-[35px]">
      {sidebar &&
        sidebar.length > 0 &&
        sidebar.map((s, i) => (
          <React.Fragment key={generateRandomKey()}>
            {s && s.length > 0 && (
              <ProfessionalSidebarLinkGroup
                title={sidebarTitles[i]}
                items={s}
                pageSlugs={pageSlugs}
              />
            )}
          </React.Fragment>
        ))}
    </Column>
  )
}

export default ProfessionalSidebar
